export default {
  header: state => state.app.header,
 ismobile: state => state.app.ismobile,
};



// WEBPACK FOOTER //
// ./src/store/getters.js